import type { AdvertMedia, AdvertMediaId, AdvertScene } from '@/types'

// Short looping clips made from the two stills below. The stills double as
// the video posters, so something shows while a clip loads.
export const ADVERT_MEDIA: Record<AdvertMediaId, AdvertMedia> = {
    local: {
        poster: '/images/advert/local.jpg',
        video: 'https://cdn.modulify.ai/files/6ae8ea97fba640947b06a3d6.mp4'
    },
    big: {
        poster: '/images/advert/big.jpg',
        video: 'https://cdn.modulify.ai/files/6ae8eafffba640947b06bdf1.mp4'
    }
}

// The advert timeline. Durations are in milliseconds and the scenes play in
// this order. Each scene's visuals live in src/components/advert/advert-scenes.tsx.
export const ADVERT_SCENES: AdvertScene[] = [
    {
        id: 'intro',
        label: 'Got a business?',
        duration: 3200,
        transcript: 'Got a business? It deserves a website that works as hard as you do.'
    },
    {
        id: 'local',
        label: 'Local businesses',
        duration: 4000,
        media: 'local',
        badge: true,
        transcript: 'Local businesses. The shop on your high street: cafés, salons, trades and shops.'
    },
    {
        id: 'big',
        label: 'Big companies',
        duration: 4000,
        media: 'big',
        badge: true,
        transcript: 'Big companies. Or the brand in every city: head offices, national brands and growing teams.'
    },
    {
        id: 'both',
        label: 'We build for both',
        duration: 3600,
        badge: true,
        transcript: 'We build websites for both.'
    },
    {
        id: 'build',
        label: 'Designed and built',
        duration: 5200,
        transcript: 'Designed. Built. Launched. Designed around your brand, sharp on every screen and built to win customers.'
    },
    {
        id: 'price',
        label: 'Affordable prices',
        duration: 3600,
        badge: true,
        transcript: 'Agency quality, without agency prices. Affordable prices for real-world budgets, whatever your size.'
    },
    {
        id: 'brand',
        label: 'Blitz Tech Services',
        duration: 4400,
        transcript: 'Blitz Tech Services. Brilliant websites. Down-to-earth prices. Get a quote today.'
    }
]

export const ADVERT_STARTS: number[] = ADVERT_SCENES.map((_, index) =>
    ADVERT_SCENES.slice(0, index).reduce((total, scene) => total + scene.duration, 0)
)

export const ADVERT_DURATION: number = ADVERT_SCENES.reduce((total, scene) => total + scene.duration, 0)
